import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface SendOtpRequest extends Partial<AxiosRequestConfig> {
  params: {
    code?: string
    email?: string
    emailOption: boolean
    number?: string
    password?: string
  }
}

interface SendOtpResponseData extends ResponseData {
  message: string
  isFirstLogin: boolean
}

export interface SendOtpResponse extends AxiosResponse {
  data: SendOtpResponseData
}

export function sendOtpAPI(
  { params }: SendOtpRequest,
  axiosInstance: AxiosInstance,
) {
  let url = ""
  if (!params.emailOption && params.code && params.number) {
    url = `/auth/mobile/${params.code}/${params.number}/otp`
  } else if (params.emailOption && params.email) {
    url = `/auth/mobile/${params.email}/signin`
  }
  return axiosInstance({
    method: "get",
    url,
    params: params.password ? { password: params.password } : undefined,
  }) as Promise<SendOtpResponse>
}
